<div class="dashboard">
	<app-header></app-header>
	<div class="container mt-4">
		<router-outlet (activate)="updateRouterOutlet($event)"></router-outlet>
	</div>
	<app-footer></app-footer>
</div>